/* Animated count-up hook + utility for premium KPI tiles */
import { useEffect, useState, useRef } from "react";

const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

export const useCountUp = (target, { duration = 1100, decimals = 0 } = {}) => {
  const [value, setValue] = useState(0);
  const startRef = useRef(null);
  const fromRef = useRef(0);

  useEffect(() => {
    if (target == null || Number.isNaN(Number(target))) {
      setValue(target);
      return;
    }
    const goal = Number(target);
    fromRef.current = value;
    startRef.current = performance.now();
    let raf;
    const tick = (now) => {
      const elapsed = now - startRef.current;
      const t = Math.min(elapsed / duration, 1);
      const eased = easeOutQuart(t);
      const v = fromRef.current + (goal - fromRef.current) * eased;
      setValue(decimals > 0 ? Number(v.toFixed(decimals)) : Math.round(v));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, duration, decimals]);

  return value;
};
